import { render } from "./CookieBox.vue?vue&type=template&id=6b7d122b"
import script from "./CookieBox.vue?vue&type=script&lang=js"
export * from "./CookieBox.vue?vue&type=script&lang=js"

import "./CookieBox.vue?vue&type=style&index=0&id=6b7d122b&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__